import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserTempPage } from './user-temp';
import { OauthService } from '../../shared/services/oauth.service';
import { CoreModule } from '../../core/core.module';
import { LocalStorageService } from '../../shared/services/localStorage.service';
import { LostPasswordService } from '../lost-password/services/lost-password.service';

@NgModule({
  declarations: [
    UserTempPage
  ],
  imports: [
    IonicPageModule.forChild(UserTempPage),
    CoreModule
  ],
  exports: [
    UserTempPage
  ],
  entryComponents: [
    UserTempPage
  ],
  providers: [
    OauthService,
    LocalStorageService,
    LostPasswordService
  ]
})
export class UserTempPageModule {}



// WEBPACK FOOTER //
// ./src/pages/user-temp/user-temp.module.ts